export default __webpack_public_path__ + "static/media/bannerMintingBgMb.79c2f7e6.png";